import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
import { Link } from 'react-router-dom';

const ProductCTA = ({ 
  productName = "this solution", 
  brandColor = "blue-600",
  headline,
  description,
  benefits = [
    "Expert consultation",
    "Tailored solutions",
    "Proven results"
  ]
}) => {
  const defaultHeadline = `Ready to Transform Your Business?`;
  const defaultDescription = `Let's discuss how ${productName} can help you achieve your goals and drive growth.`;

  // Map brand colors to Tailwind classes for proper purging
  const colorMap = {
    'blue-600': { text: 'text-blue-600', bg: 'bg-blue-600', hover: 'hover:bg-blue-700' },
    'teal-600': { text: 'text-teal-600', bg: 'bg-teal-600', hover: 'hover:bg-teal-700' },
    'green-600': { text: 'text-green-600', bg: 'bg-green-600', hover: 'hover:bg-green-700' },
    'purple-600': { text: 'text-purple-600', bg: 'bg-purple-600', hover: 'hover:bg-purple-700' },
    'indigo-600': { text: 'text-indigo-600', bg: 'bg-indigo-600', hover: 'hover:bg-indigo-700' },
    'orange-600': { text: 'text-orange-600', bg: 'bg-orange-600', hover: 'hover:bg-orange-700' },
    'sky-600': { text: 'text-sky-600', bg: 'bg-sky-600', hover: 'hover:bg-sky-700' },
    'pink-600': { text: 'text-pink-600', bg: 'bg-pink-600', hover: 'hover:bg-pink-700' },
  };

  const colors = colorMap[brandColor] || colorMap['blue-600'];

  return (
    <div className="bg-white rounded-2xl p-8 border-2 border-slate-200 shadow-lg hover:shadow-xl transition-shadow">
      <div className="text-center mb-8">
        <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
          {headline || defaultHeadline}
        </h3>
        <p className="text-lg text-gray-600 leading-relaxed">
          {description || defaultDescription}
        </p>
      </div>

      <div className="space-y-3 mb-8">
        {benefits.map((benefit, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.3, delay: index * 0.1 }}
            viewport={{ once: true }}
            className="flex items-center space-x-3"
          >
            <CheckCircle2 className={`w-6 h-6 ${colors.text} flex-shrink-0`} />
            <p className="text-gray-700 font-medium">{benefit}</p>
          </motion.div>
        ))}
      </div>

      <Link to="/contact">
        <motion.button
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          className={`w-full ${colors.bg} ${colors.hover} text-white px-8 py-4 rounded-xl text-lg font-bold shadow-lg transition-all flex items-center justify-center space-x-2 group`}
        >
          <span>Get in Touch</span>
          <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
        </motion.button>
      </Link>

      <p className="text-center text-sm text-gray-500 mt-4">
        No obligations • Free consultation • Quick response
      </p>
    </div>
  );
};

export default ProductCTA;
